module.exports = __webpack_public_path__ + "static/footer-04d21546cfff852a27d592e1fcbb7cef.png";